/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module BotTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Chatbot {
    [k: string]: any;
}
/**
 * This interface was referenced by `Chatbot`'s JSON-Schema
 * via the `definition` "ProcessIntentParameters".
 */
export interface ProcessIntentParameters {
    Intent: ConversationIntent;
    Module: Component;
}
/**
 * This interface was referenced by `Chatbot`'s JSON-Schema
 * via the `definition` "ProcessIntentReturn".
 */
export interface ProcessIntentReturn {
    /**
     * Recommendation to bot service
     */
    Recommendation?: string;
}

/**
 * This interface was referenced by `Chatbot`'s JSON-Schema
 * via the `definition` "ConversationIntent".
 */
export enum ConversationIntent {
    Support = 'Support',
    Recommendation = 'Recommendation'
}
/**
 * This interface was referenced by `Chatbot`'s JSON-Schema
 * via the `definition` "Component".
 */
export enum Component {
    Installer = 'Installer',
    Game = 'Game',
    Share = 'Share',
    GameStream = 'GameStream'
}


}
